"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuntimeEnvironment = exports.DevCollectorTarget = exports.LocalCollectorTarget = exports.SnowplowRegion = void 0;
var SnowplowRegion;
(function (SnowplowRegion) {
    SnowplowRegion["US"] = "us";
    SnowplowRegion["EU"] = "eu";
})(SnowplowRegion || (exports.SnowplowRegion = SnowplowRegion = {}));
var LocalCollectorTarget;
(function (LocalCollectorTarget) {
    LocalCollectorTarget["Micro"] = "micro";
    LocalCollectorTarget["Mini"] = "mini";
    LocalCollectorTarget["Dev1"] = "dev1";
})(LocalCollectorTarget || (exports.LocalCollectorTarget = LocalCollectorTarget = {}));
var DevCollectorTarget;
(function (DevCollectorTarget) {
    DevCollectorTarget["Mini"] = "mini";
    DevCollectorTarget["Dev1"] = "dev1";
})(DevCollectorTarget || (exports.DevCollectorTarget = DevCollectorTarget = {}));
var RuntimeEnvironment;
(function (RuntimeEnvironment) {
    RuntimeEnvironment["Local"] = "local";
    RuntimeEnvironment["Dev"] = "dev";
    RuntimeEnvironment["Staging"] = "staging";
    RuntimeEnvironment["Prod"] = "prod";
})(RuntimeEnvironment || (exports.RuntimeEnvironment = RuntimeEnvironment = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBS0EsSUFBWSxjQUdYO0FBSEQsV0FBWSxjQUFjO0lBQ3RCLDJCQUFTLENBQUE7SUFDVCwyQkFBUyxDQUFBO0FBQ2IsQ0FBQyxFQUhXLGNBQWMsOEJBQWQsY0FBYyxRQUd6QjtBQUVELElBQVksb0JBSVg7QUFKRCxXQUFZLG9CQUFvQjtJQUM1Qix1Q0FBZSxDQUFBO0lBQ2YscUNBQWEsQ0FBQTtJQUNiLHFDQUFhLENBQUE7QUFDakIsQ0FBQyxFQUpXLG9CQUFvQixvQ0FBcEIsb0JBQW9CLFFBSS9CO0FBRUQsSUFBWSxrQkFHWDtBQUhELFdBQVksa0JBQWtCO0lBQzFCLG1DQUFhLENBQUE7SUFDYixtQ0FBYSxDQUFBO0FBQ2pCLENBQUMsRUFIVyxrQkFBa0Isa0NBQWxCLGtCQUFrQixRQUc3QjtBQUVELElBQVksa0JBS1g7QUFMRCxXQUFZLGtCQUFrQjtJQUMxQixxQ0FBZSxDQUFBO0lBQ2YsaUNBQVcsQ0FBQTtJQUNYLHlDQUFtQixDQUFBO0lBQ25CLG1DQUFhLENBQUE7QUFDakIsQ0FBQyxFQUxXLGtCQUFrQixrQ0FBbEIsa0JBQWtCLFFBSzdCIn0=


// WEBPACK FOOTER //
// ../../../src/utils/types.ts